export default __webpack_public_path__ + "static/media/stair_6.974f3829.png";